import React from 'react';
import AlertBar from '../common/AlertBar';

const OfflineAlert = () => (
  <AlertBar alertType="warning">
    <strong>Computer Offline</strong> Please connect to the internet to load the latest data.
  </AlertBar>
);

export default OfflineAlert;



// WEBPACK FOOTER //
// ./src/components/Alerts/OfflineAlert.js